import request from '@/utils/request'

export function fetchOrderOne(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/user/order/query/one',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/views/activity_174/api.js